import fontsStyles from '../../../styles/modules/fonts.module.scss';
import styles from './ErrorPage.module.scss';

export interface ErrorPageProps {
  statusCode: number;
  name: string;
  description: string;
}

function ErrorPage({ statusCode, name, description }: ErrorPageProps) {
  return (
    <div className={styles.componentStyle}>
      <div className={styles.errorCode}>
        <p className={fontsStyles.montserrat}>{statusCode}</p>
      </div>
      <div className={styles.errorText}>
        <p className={fontsStyles.montserrat}>{name}</p>
      </div>
      <div className={styles.mtMedium}>
        <p className={`${styles.textPrewrap} ${styles.textSmall}`}>{description}</p>
      </div>
    </div>
  );
}

export default ErrorPage;
